import { EMaxPrepay } from '../../../../api-models/common/json_query';

export const MAX_PREPAY_VALUE_TO_LABEL = {
  [EMaxPrepay.Month]: 'не более месяца',
  [EMaxPrepay.TwoMonths]: 'не более 2 месяцев',
  [EMaxPrepay.ThreeMonths]: 'не более 3 месяцев',
};
